import { Sparkles } from 'lucide-react';
import { formatBookingId } from '../../../../../utils/supportHelpers';

const TripContextCard = ({ activeVoucherInfo, bookingId }) => {
  const bookingIdFormatted = formatBookingId(bookingId);

  return (
    <div className="max-w-md mx-auto bg-white px-4 py-2.5 rounded-xl border border-gray-100 shadow-sm flex items-center justify-between">
      <div className="flex items-center gap-2.5">
        <div className="w-7 h-7 rounded-lg bg-[#067978]/10 text-[#067978] flex items-center justify-center">
          <Sparkles size={14} />
        </div>
        <div>
          <p className="text-xs font-semibold text-gray-800">
            {activeVoucherInfo?.tour_info?.destinations?.[0]?.city || 'Tour Trip'}
          </p>
          <p className="text-[11px] text-gray-400">
            Booking:{' '}
            <span className="font-mono font-medium text-gray-600 lowercase">
              #{bookingIdFormatted}
            </span>
          </p>
        </div>
      </div>
      <span className="text-[10px] font-medium uppercase px-2 py-0.5 bg-emerald-50 text-emerald-600 rounded-md border border-emerald-100">
        {activeVoucherInfo?.status || 'Confirmed'}
      </span>
    </div>
  );
};

export default TripContextCard;
